import React from 'react';

import {
  Table,
  Alert,
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from 'reactstrap';

import utils from '../utils.js';

class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: null,
      balanceTransactions: null,
      errorMessage: null,
    };
  }

  async componentDidMount() {
    const {
      customer,
      balanceTransactions,
      errorMessage,
    } = await utils.getStripeCustomerInfo();

    this.setState({
      customer,
      balanceTransactions,
      errorMessage,
    });
  }

  renderErrors() {
    if (this.state.errorMessage) {
      return <Alert color="danger">{this.state.errorMessage}</Alert>;
    }
    if (this.state.successMessage) {
      return <Alert color="success">{this.state.successMessage}</Alert>;
    }
  }

  renderResub() {
    if (!this.props.license || this.props.license.licenseStatus === 'active')
      return null;
    return (
      <div className="mb-3">
        {this.props.license.licenseType !== 'lite' ? (
          <div className="mb-3">
            If you want to resub to Pro, please contact support on Discord or
            support@snailbot.io
          </div>
        ) : null}
        <Button
          color="success"
          type="button"
          href={`/dashboard/subscribe?plan=lite`}
          target="_blank"
        >
          Subscribe to Lite
        </Button>
      </div>
    );
  }

  getCreditsToBalance(balance) {
    return -(balance / 100);
  }

  renderCredits() {
    if (!this.state.customer) return null;
    const credits = this.getCreditsToBalance(this.state.customer.balance);
    return (
      <div className="mb-3">
        <div className="mb-2">
          <b>Credits</b>: ${credits}
        </div>
        <small className="mb-2">
          Credits will automatically reduce the amount you pay for your next
          renewal or subscription update (e.g. adding Lite instances).
        </small>
      </div>
    );
  }

  renderBalanceTransactions() {
    if (!this.state.balanceTransactions) return null;
    return (
      <div className="mb-3">
        <div className="mb-2">
          <b>Recent Credit Adjustments</b>
        </div>
        <Table className="align-items-center table-flush" responsive>
          <thead className="">
            <tr>
              <th scope="col">Amount</th>
              <th scope="col">Balance</th>
              <th scope="col">Reason</th>
              <th scope="col">Type</th>
            </tr>
          </thead>
          <tbody>
            {this.state.balanceTransactions.map((t) => {
              const creditAmt = this.getCreditsToBalance(t.amount);
              const creditPrefix = creditAmt > 0 ? '+' : '';
              const endingBalance = this.getCreditsToBalance(t.ending_balance);
              return (
                <tr key={t.id}>
                  <td>
                    {creditPrefix}
                    {creditAmt}
                  </td>
                  <td>{endingBalance}</td>
                  <td>{t.description || '-'}</td>
                  <td>{utils.titleCase(t.type)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    return (
      <>
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="8">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Billing</h3>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {this.renderErrors()}
                  {this.renderResub()}
                  <Button
                    color="primary"
                    type="button"
                    href={`${utils.getEndpoint()}/stripe/customer-portal`}
                    target="_blank"
                    className="mb-3"
                  >
                    Manage Subscription
                  </Button>
                  {this.renderCredits()}
                  {this.renderBalanceTransactions()}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Billing;
